import { getBlockedDeliveryDates } from '../../scripts/deliveryDateRules'

export default {
	data() {
		return {
            commonBlockedDelivery: {
                cities: [],
                dates: []
            },
		}
	},
    methods: {
        fillBlockedDeliveryDates() {
            getBlockedDeliveryDates()
                .then(res => {
                    if (res.data.data.attributes.excludedCitiesFromNonWorkingDates) {
                        this.commonBlockedDelivery.cities = res.data.data.attributes.excludedCitiesFromNonWorkingDates.split(',');
                        res.data.data.attributes.nonWorkingDates.split(', ').map(date => {
                            if (date.includes('-')) {
                                this.commonBlockedDelivery.dates.push({
                                    from: date.split('-')[0],
                                    to: date.split('-')[1],
                                });
                            } else {
                                this.commonBlockedDelivery.dates.push(date);
                            }
                        });
                    }
                });
        }
    },
    mounted() {
        this.fillBlockedDeliveryDates();
    }
}
